export { AutoSuggest } from './src/auto-suggest';



// WEBPACK FOOTER //
// ./src/auto-suggest/index.ts